<template>
  <div class="card">
    <!-- <template v-if="list.length==0">
      <div class="no-data">
        <img src="@images/none.png" />
        <div>暂无数据</div>
      </div>
    </template>
    <template v-else>
      <div class="list">
        <div class="item" v-for="(item,index) in list" @click="$router.push({name:'newsDetail',params:{id:item.id}})">
          <span class="read" v-if="item.status==0"></span>
          <span class="title" v-html="item.content"></span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </template> -->
    <!-- <el-table :data="tableData" stripe style="width: 100%" @row-click="$router.push({name:'newsDetail',params:{id:item.id}})"> -->
    <el-table :data="tableData" stripe style="width: 100%" @row-click="detail">
      <el-table-column label="消息内容">
        <template slot-scope="scope">
          <div class="list-content">
            <span class="unread" v-if="scope.row.isRead==0"></span>
            <span v-html="scope.row.content"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column :prop="item.prop" :label="item.label" :width="item.width" v-for="item in column">
      </el-table-column>

    </el-table>
    <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination> -->
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      list: [],
      tableData: [],
      column: [
        // { prop: "content", label: "消息内容", width: "" },
        { prop: "typeName", label: "消息类型", width: 140 },
        { prop: "sendTime", label: "时间", width: 160 },
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // userMess: this.$store.state.user.user
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user.user
    }
  },
  watch: {},
  methods: {
    detail(row, column, event) {
      this.$router.push({ name: 'newsDetail', params: { id: row.id } })
    },
    getList() {
      // console.log(this.userMess)
      let params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        volunteerId: this.userMess.id
      }
      this.$api.messageList(params).then(res => {
        // console.log(res)
        this.tableData = res.data.rows
        this.total = res.data.total
      })
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
      // console.log(`当前页: ${val}`);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getList()
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.list-content {
  padding-left: 8px;
  .unread {
    position: absolute;
    top: calc(50% - 4px);
    left: 4px;
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background-color: chocolate;
    display: inline-block;
  }
}
</style>
